import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4.387 3h15.226a1 1 0 0 1 .948 1.316l-5.105 15.316a2 2 0 0 1 -1.898 1.368h-3.116a2 2 0 0 1 -1.898 -1.368l-5.104 -15.316a1 1 0 0 1 .947 -1.316","key":"svg-0"}],["path",{"d":"M5 9h14","key":"svg-1"}],["path",{"d":"M7 15h10","key":"svg-2"}]]

const IconChartFunnel = createReactComponent('outline', 'chart-funnel', 'ChartFunnel', __iconNode);

export default IconChartFunnel;